export default __webpack_public_path__ + "static/media/certifi-2.8d150d6d.png";